import * as React from "react";
import Checkbox from "@mui/material/Checkbox";
import { AppContext } from "../../ContextApi/AppContext/AppContext";

export default function ControlledCheckbox() {
  const { updateState } = React.useContext(AppContext);
  const [checked, setChecked] = React.useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    updateState("remember", event.target.checked);
  };

  return (
    <Checkbox
      checked={checked}
      onChange={handleChange}
      inputProps={{ "aria-label": "controlled" }}
    />
  );
}
